import React from "react"
import css from "./Preloader.module.scss"

// A skeleton shimmer — playback now streams progressively (starts before the
// whole file is downloaded), so there's no real byte count to show; this is
// just "something is happening" while the pad waits for enough to buffer.
function Preloader() {
  return <div className={css.loader} />
}

export default Preloader
